"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _createSvgIcon = _interopRequireDefault(require("../utils/createSvgIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = (0, _createSvgIcon["default"])( /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("clipPath", {
  id: "clip-path"
}), /*#__PURE__*/_react["default"].createElement("clipPath", {
  id: "clip-path-3"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M12.5 2.16H9.71A1.34 1.34 0 0 0 8.37 3.5v25a1.34 1.34 0 0 0 1.34 1.34h2.79zM22.29 2.16H13.5v27.68h8.79a1.34 1.34 0 0 0 1.34-1.34v-25a1.34 1.34 0 0 0-1.34-1.34zm0 24.23h-5.5v-1h5.5zm0-3.29h-2.94v-1h2.93zm0-3.3h-2.94v-1h2.93zm0-3.3h-5.5v-1h5.5zm0-3.3h-2.94v-1h2.93zm0-3.3h-2.94v-1h2.93zm0-3.3h-5.5v-1h5.5z"
})));
module.exports = exports.default;